import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-request-ge-single-sign',
  templateUrl: './request-ge-single-sign.component.html',
  styleUrls: ['./request-ge-single-sign.component.scss']
})
export class RequestGeSingleSignComponent implements OnInit {
  year;
  fileUrl = '../../../../../assets/pdf-register/GESSORegistrationGuide.pdf';
  url: string;
  URLS = [
    '../../../../../assets/images/register/vision_still.jpg',
    '../../../../../assets/images/register/power_plant.jpg',
    '../../../../../assets/images/register/arabelle.jpg',
    '../../../../../assets/images/register/coal_pp.jpg',
    '../../../../../assets/images/register/lights.jpg'
  ];
  constructor(private sanitizer: DomSanitizer) {
    this.url = this.URLS.find((_, i, ar) => Math.random() < 1 / (ar.length - i));
  }

  ngOnInit(): void {
    const year = new Date();
    this.year = year.getFullYear();
  }

  getUrl() {
    return `url('${this.url}')`;
  }
  goPageRegister() {
    window.open('https://nextgen.ge-registrar.com/b2bregistration/index.html#/registration');
  }
}
